import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { hasAdminRole } from '../../core/auth/auth.service';

/**
 * ARC-070: o claim `role` do JWT nem sempre é string (token antigo,
 * multi-role/PBAC pode trazer array, ou o claim pode vir ausente) — nunca
 * assumir string sem checar o tipo em runtime.
 */
function getRoleFromToken(token: string): string | string[] | undefined {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role;
  } catch {
    return undefined;
  }
}

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('compleet_access_token');

  if (!token) {
    return router.createUrlTree(['/auth/login']);
  }

  if (!hasAdminRole(getRoleFromToken(token))) {
    return router.createUrlTree(['/403']);
  }

  return true;
};
